const productDetailsFragment = /* GraphQL */ `
  fragment productDetailsFragment on SkuBaseDetails {
    productPageId
    skuBaseNumber
    displayTitle
    subtitle
    rating
    reviewCount
    isMadeInUsa
    availability
    productPageUrl
    absoluteProductPageUrl
    segmentCategorization
    imageLink
    brand
    brandImageUrl
    unit
    isGarageSale
    isNewProduct
    highPrice
    lowPrice
    superMarketAffinity
    hasActiveRebate
    ribbonText
    pricing {
      hasMultiplePrices
      salePriceString
      percentOffString
      strikeThroughPrice
    }
    specs {
      title
      value
      requiresVariantSelection
      isKeySpec
      ordinality
    }
    skuVariantSummaries {
      skuNumber
      skuName
      skuBase
      availability
    }
  }
`

export default productDetailsFragment
